<template>
  <div class="app-container">
    <el-card class="search-card" shadow="never">
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="运营商名称">
          <el-input
            v-model="queryParams.operatorName"
            placeholder="请输入运营商名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryParams.status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1" />
            <el-option label="禁用" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="action-card" shadow="never">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      <el-button type="danger" icon="el-icon-delete" :disabled="multiple" @click="handleDelete">批量删除</el-button>
      <el-button type="info" plain icon="el-icon-question" @click="handleGuide">操作指引</el-button>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="operatorList" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" align="center" />
        <el-table-column label="运营商名称" prop="operatorName" show-overflow-tooltip />
        <el-table-column label="运营商编号" prop="operatorCode" show-overflow-tooltip />
        <el-table-column label="绑定用户" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getSysUserLabel(scope.row.sysUserId) }}
          </template>
        </el-table-column>
        <el-table-column label="联系人" prop="contactPerson" show-overflow-tooltip />
        <el-table-column label="联系电话" prop="contactPhone" show-overflow-tooltip />
        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
              {{ scope.row.statusDesc }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" width="180" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        v-show="total > 0"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="getList"
        @current-change="getList"
      />
    </el-card>

    <el-dialog :title="title" :visible.sync="open" width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item label="运营商名称" prop="operatorName">
          <el-input v-model="form.operatorName" placeholder="请输入运营商名称" />
        </el-form-item>
        <el-form-item label="运营商编号" prop="operatorCode">
          <el-input v-model="form.operatorCode" placeholder="请输入运营商编号" />
        </el-form-item>
        <el-form-item label="AppKey" prop="appkey">
          <el-input v-model="form.appkey" placeholder="请输入监管平台 appkey" />
        </el-form-item>
        <el-form-item label="AppSecret" prop="appsecret">
          <el-input v-model="form.appsecret" placeholder="请输入监管平台 appsecret" />
        </el-form-item>
        <el-form-item label="接入AppKey" prop="visitAppKey">
          <el-input v-model="form.visitAppKey" placeholder="外部系统访问本系统的 AppKey（可选）" />
        </el-form-item>
        <el-form-item label="接入AppSecret" prop="visitAppSecret">
          <el-input v-model="form.visitAppSecret" placeholder="外部系统访问本系统的 AppSecret（可选）" show-password />
        </el-form-item>
        <el-form-item label="推送地址" prop="pushServerUrl">
          <el-input v-model="form.pushServerUrl" placeholder="请输入推送服务器地址" />
        </el-form-item>
        <el-form-item label="绑定用户" prop="sysUserId">
          <el-select
            v-model="form.sysUserId"
            filterable
            clearable
            placeholder="请选择绑定用户"
            style="width: 100%"
          >
            <el-option
              v-for="item in sysUserOptions"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="联系人" prop="contactPerson">
          <el-input v-model="form.contactPerson" placeholder="请输入联系人" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input v-model="form.contactPhone" placeholder="请输入联系电话" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listOperator, getOperator, addOperator, updateOperator, delOperator } from '@/api/coo/operator'
import { getRequest } from '@/utils/api'

export default {
  name: 'OperatorList',
  data() {
    return {
      loading: true,
      open: false,
      title: '',
      operatorList: [],
      sysUserOptions: [],
      total: 0,
      multiple: true,
      ids: [],
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        operatorName: undefined,
        status: undefined
      },
      form: {},
      rules: {
        operatorName: [{ required: true, message: '运营商名称不能为空', trigger: 'blur' }],
        operatorCode: [{ required: true, message: '运营商编号不能为空', trigger: 'blur' }],
        appkey: [{ required: true, message: 'AppKey 不能为空', trigger: 'blur' }],
        appsecret: [{ required: true, message: 'AppSecret 不能为空', trigger: 'blur' }],
        sysUserId: [{ required: true, message: '绑定用户不能为空', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadSysUserOptions()
    this.getList()
    this.$guide.startGuideIfNeeded('operator')
  },
  methods: {
    handleGuide() {
      this.$guide.startGuide('operator')
    },
    loadSysUserOptions() {
      getRequest('/api/system/user/page?page=1&size=1000').then(response => {
        const list = response && response.data && response.data.list ? response.data.list : []
        this.sysUserOptions = list.map(item => {
          const id = String(item.id)
          const name = item.name || item.username || id
          const extra = item.username && item.username !== name ? ` (${item.username})` : ''
          return {
            id,
            label: `${name}${extra}`
          }
        })
      })
    },
    getSysUserLabel(sysUserId) {
      if (!sysUserId) {
        return '-'
      }
      const matched = this.sysUserOptions.find(item => item.id === String(sysUserId))
      return matched ? matched.label : String(sysUserId)
    },
    getList() {
      this.loading = true
      listOperator(this.queryParams).then(response => {
        this.operatorList = response.data
        this.total = response.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        operatorName: undefined,
        status: undefined
      }
      this.handleQuery()
    },
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.multiple = !selection.length
    },
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '新增运营商'
    },
    handleUpdate(row) {
      this.reset()
      getOperator(row.id).then(response => {
        this.form = response.data || {}
        if (this.form.sysUserId !== undefined && this.form.sysUserId !== null) {
          this.form.sysUserId = String(this.form.sysUserId)
        }
        this.open = true
        this.title = '编辑运营商'
      })
    },
    handleDelete(row) {
      const ids = row.id || this.ids.join(',')
      this.$confirm('确认删除选中的运营商吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return delOperator(ids)
      }).then(() => {
        this.getList()
        this.$message.success('删除成功')
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const payload = {
            ...this.form,
            sysUserId: this.form.sysUserId ? String(this.form.sysUserId) : this.form.sysUserId
          }
          if (payload.id) {
            updateOperator(payload).then(response => {
              if (response.code === 200) {
                this.$message.success(response.message || '修改成功')
                this.open = false
                this.getList()
              } else {
                this.$message.error(response.message || '修改失败')
              }
            })
          } else {
            addOperator(payload).then(response => {
              if (response.code === 200) {
                this.$message.success(response.message || '新增成功')
                this.open = false
                this.getList()
              } else {
                this.$message.error(response.message || '新增失败')
              }
            })
          }
        }
      })
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.form = {
        sysUserId: undefined,
        status: 1,
        pushServerUrl: 'http://114.94.58.207:18090'
      }
    }
  }
}
</script>

<style scoped>
.search-card,
.action-card {
  margin-bottom: 15px;
}
</style>
